import React, { Component } from "react";
import { withStyles, Button } from "@material-ui/core";
import Delete from "@material-ui/icons/Delete";

const styles = (theme) => ({
  root: {
    width: "100%",
    overflowX: "scroll",
  },
});

class Articles extends Component {
  state = {
    title: "",
    publisher: "",
    issn: "",
    impact_factor: "",
    no_co_au: "",
    main_au: "",
    institution: "",
    api_score: "",
    year: "",
    articles: [],
  };

  componentDidMount() {
    //console.log(this.props)
    this.setState({
      articles: this.props.articles,
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.setState({
        articles: this.props.articles,
      });
    }
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onChangeNew = (name, value, index, array) => {
    let data = this.state[array];
    data[index][name] = value;

    this.setState({
      [array]: data,
    });
  };

  onSubmit = () => {
    let d = {
      title: this.state.title,
      publisher: this.state.publisher,
      issn: this.state.issn,
      impact_factor: this.state.impact_factor,
      no_co_au: this.state.no_co_au,
      main_au: this.state.main_au,
      institution: this.state.institution,
      api_score: this.state.api_score,
      year: this.state.year,
    };

    let articles = this.state.articles;
    articles.push(d);
    this.setState(
      {
        articles,
      },
      () => {
        this.props.setArticles(articles);
        this.setState({
          title: "",
          publisher: "",
          issn: "",
          impact_factor: "",
          no_co_au: "",
          main_au: "",
          institution: "",
          api_score: "",
          year: "",
        });
      }
    );
  };

  onDelete = (index) => {
    let articles = this.state.articles;
    articles.splice(index, 1);
    this.props.setArticles(articles);
    this.setState({
      articles,
    });
  };
  render() {
    let { classes } = this.props;
    return (
      <div className={classes.root}>
        <table width="100%" className="table">
          <thead>
            <tr>
              <td width="20%">Title with Page Numbers</td>
              <td width="15%">Book Title, editor & publisher and Year</td>

              <td width="7%">ISSN/ ISBN No.</td>
              <td width="5%">Whether Peer Reviewed Impact Factor, if any </td>
              <td width="5%">No. of Co-author</td>
              <td width="5%">Whether you are the main author</td>
              <td width="5%">
                Whether at the time of publication Affiliating Institution was
                same Yes/ No
              </td>
              <td width="10%">API Score</td>
              <td width="10%">Year</td>

              <td width="2%">Click + to Add</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td width="10%" style={{padding: 0}}>
                <textarea
                  className="form-control"
                  type="text"
                  name="title"
                  value={this.state.title}
                  onChange={this.onChange}
                  placeholder="Title with Page Numbers"
                />
              </td>
              <td width="15%" style={{padding: 0}}>
                <textarea
                  className="form-control"
                  type="text"
                  name="publisher"
                  value={this.state.publisher}
                  onChange={this.onChange}
                  placeholder="Book Title, Editor & Publisher"
                />
              </td>
              <td style={{padding: 0}}>
                <textarea
                  className="form-control"
                  type="text"
                  name="issn"
                  value={this.state.issn}
                  onChange={this.onChange}
                  placeholder="ISSN/ ISBN No"
                />
              </td>

              <td style={{padding: 0}}>
                <textarea
                  className="form-control"
                  type="text"
                  name="impact_factor"
                  value={this.state.impact_factor}
                  onChange={this.onChange}
                  placeholder="Whether Peer Reviewed Impact Factor, if any"
                />
              </td>

              <td style={{padding: 0}}>
                <textarea
                  className="form-control"
                  type="text"
                  name="no_co_au"
                  value={this.state.no_co_au}
                  onChange={this.onChange}
                  placeholder="No. of 
                                    Co-author"
                />
              </td>

              <td style={{padding: 0}}>
                <textarea
                  className="form-control"
                  type="text"
                  name="main_au"
                  value={this.state.main_au}
                  onChange={this.onChange}
                  placeholder="Whether you are the main author"
                />
              </td>

              <td style={{padding: 0}}>
                <textarea
                  className="form-control"
                  type="text"
                  name="institution"
                  value={this.state.institution}
                  onChange={this.onChange}
                  placeholder="Yes/No"
                />
              </td>

              <td style={{padding: 0}}>
                <textarea
                  className="form-control"
                  type="text"
                  name="api_score"
                  value={this.state.api_score}
                  onChange={this.onChange}
                  placeholder="API Score"
                />
              </td>

              <td style={{padding: 0}}>
                <textarea
                  className="form-control"
                  type="text"
                  name="year"
                  value={this.state.year}
                  onChange={this.onChange}
                  placeholder="Year"
                />
              </td>

              <td style={{padding: 0}}>
                <Button
                  variant="outlined"
                  onClick={this.onSubmit}
                  type="button"
                >
                  +
                </Button>
              </td>
            </tr>
          </tbody>
          <tbody>
            {this.state.articles.map((el, index) => (
              <tr key={index}>
                <td>
                  <textarea
                    className="form-control"
                    type="text"
                    rows="5"
                    style={{ width: "100%" }}
                    name="title"
                    value={el.title}
                    onChange={(e) =>
                      this.onChangeNew(
                        "title",
                        e.target.value,
                        index,
                        "articles"
                      )
                    }
                    placeholder="Title with Page Numbers"
                  />
                </td>
                <td>
                  <textarea
                    className="form-control"
                    type="text"
                    rows="5"
                    style={{ width: "100%" }}
                    name="publisher"
                    value={el.publisher}
                    onChange={(e) =>
                      this.onChangeNew(
                        "publisher",
                        e.target.value,
                        index,
                        "articles"
                      )
                    }
                    placeholder="Book Title, editor & publisher and Year	"
                  />
                </td>

                <td>
                  <textarea
                    className="form-control"
                    type="text"
                    rows="5"
                    style={{ width: "100%" }}
                    name="issn"
                    value={el.issn}
                    onChange={(e) =>
                      this.onChangeNew(
                        "issn",
                        e.target.value,
                        index,
                        "articles"
                      )
                    }
                    placeholder="ISSN/ ISBN No.	"
                  />
                </td>
                <td>
                  <textarea
                    className="form-control"
                    type="text"
                    rows="5"
                    style={{ width: "100%" }}
                    name="impact_factor"
                    value={el.impact_factor}
                    onChange={(e) =>
                      this.onChangeNew(
                        "impact_factor",
                        e.target.value,
                        index,
                        "articles"
                      )
                    }
                    placeholder="Whether Peer Reviewed Impact Factor, if any	"
                  />
                </td>
                <td>
                  <textarea
                    className="form-control"
                    type="text"
                    rows="5"
                    style={{ width: "100%" }}
                    name="no_co_au"
                    value={el.no_co_au}
                    onChange={(e) =>
                      this.onChangeNew(
                        "no_co_au",
                        e.target.value,
                        index,
                        "articles"
                      )
                    }
                    placeholder="No. of Co-author	"
                  />
                </td>
                <td>
                  <textarea
                    className="form-control"
                    type="text"
                    rows="5"
                    style={{ width: "100%" }}
                    name="main_au"
                    value={el.main_au}
                    onChange={(e) =>
                      this.onChangeNew(
                        "main_au",
                        e.target.value,
                        index,
                        "articles"
                      )
                    }
                    placeholder="Whether you are the main author	"
                  />
                </td>
                <td>
                  <textarea
                    className="form-control"
                    type="text"
                    rows="5"
                    style={{ width: "100%" }}
                    name="institution"
                    value={el.institution}
                    onChange={(e) =>
                      this.onChangeNew(
                        "institution",
                        e.target.value,
                        index,
                        "articles"
                      )
                    }
                    placeholder="Yes/No"
                  />
                </td>
                <td>
                  <textarea
                    className="form-control"
                    type="text"
                    rows="5"
                    style={{ width: "100%" }}
                    name="api_score"
                    value={el.api_score}
                    onChange={(e) =>
                      this.onChangeNew(
                        "api_score",
                        e.target.value,
                        index,
                        "articles"
                      )
                    }
                    placeholder="API Score"
                  />
                </td>
                <td>
                  <textarea
                    className="form-control"
                    type="text"
                    rows="5"
                    style={{ width: "100%" }}
                    name="year"
                    value={el.year}
                    onChange={(e) =>
                      this.onChangeNew(
                        "year",
                        e.target.value,
                        index,
                        "articles"
                      )
                    }
                    placeholder="Year"
                  />
                </td>

                <td>
                  <Delete onClick={this.onDelete.bind(this, index)} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default withStyles(styles)(Articles);
